export default __webpack_public_path__ + "static/media/sns_x_b.81410477.png";